import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { getDefaultLandingPathForTenant } from 'helpers';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    gap: 16
  }
}));

const publicAuthPaths = ['/sign-in', '/ssoLogin', '/authentication', '/reset-password', '/not-found', '/not-authorized', '/bootstrap', '/forgot'];

const Bootstrap = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const userReady = useSelector(store => store.user.ready);
  const userLoading = useSelector(store => store.user.loading);
  const xToken = useSelector(store => store.user.xToken);
  const selectedTenantId = useSelector(store => store.user.selectedTenant?.tenantId);
  const hasSessionToken = !!(xToken || window.localStorage.getItem('GCM-xToken'));

  useEffect(() => {
    if (userReady) {
      const tenantId = selectedTenantId ?? window.localStorage.getItem('GCM-tenantId');
      const landingPath = getDefaultLandingPathForTenant(tenantId);
      const returnTo = location.state?.returnTo;
      const destination =
        returnTo && !publicAuthPaths.some(p => returnTo.startsWith(p))
          ? returnTo
          : landingPath;
      history.replace(destination);
      return;
    }

    if (!userLoading && !hasSessionToken) {
      history.replace('/sign-in');
    }
  }, [userReady, selectedTenantId, userLoading, hasSessionToken]);

  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
};

export default Bootstrap;
